module.exports = __webpack_public_path__ + "static/media/DSC_0070.4949e425.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0070.jpg
// module id = 553
// module chunks = 0